module.exports = __webpack_public_path__ + "media/images/desktop/text-fragment-8811233b60722601ece259f75ac2cb68.svg";